'use client';

import clsx from 'clsx';

import { Section } from '~/components';
import { Typography } from '@bgzt/ui';
import { utilStyles } from '~/styles';

import styles from './RelatedKeywords.module.css';

type Props = { keywords?: string[]; onClickKeyword?: (keyword: string) => void };

export const RelatedKeywords = ({ keywords, onClickKeyword }: Props) => {
  if (!keywords || keywords?.length < 1) return null;
  return (
    <Section className={styles.container}>
      <Typography variant={'L7'} color={'gray-900'} className={styles.label}>
        연관
      </Typography>
      <div className={clsx(styles.keywords, utilStyles.scrollXHidden)}>
        {keywords?.map((keyword) => (
          <div key={keyword} className={styles.keyword} onClick={() => onClickKeyword?.(keyword)}>
            <Typography variant={'L8'} color={'gray-600'}>
              {keyword}
            </Typography>
          </div>
        ))}
      </div>
    </Section>
  );
};
